/* eslint-disable no-restricted-syntax */
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { isArray, orderBy, cloneDeep, capitalize } from 'lodash';
import { useParams } from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroll-component';
import * as action from './store/ProductHistory.action';
import * as bomAction from '../DevlopmentOrder/Bom/store/BOMConfig.action';
import SearchBar from '../../Components/Utility/FilterAction/SearchBar';
import Loader from '../../Components/Utility/Loader/Loader';
import { Page_Size, SetSequenceForHistoryModule, shortenandHoverString } from '../../Components/helper';
import DevelopmenorderFields from './DevelopmenorderFields';
import ProductIdentifierFields from './ProductIdentifierFields';
import './History.css';
import * as masterAction from '../SystemMasters/Store/SystemMasters.action';
import RenderLhsRhsValues from '../DAM/DamHistory/RenderLhsRhsValues';

function ProductHistory() {
  const dispatch = useDispatch();
  const { devOrderId } = useParams();
  const { t } = useTranslation('common');

  const [state, setState] = useState({
    isLoading: false,
    history: [],
    users: [],
    searchValue: '',
    searchText: '',
    newHistory: [],
    hasMore: false,
    pageIndex: 1,
    pageSize: Page_Size,
    searchLoader: false,
  });
  const reducers = useSelector((redState) => redState);
  const {
    BOMConfigDetails: { productDetails },
    productHistoryDetails: { historyListRecords, historyList, userList },
    SystemMastersDetails: { productIdentifierList },
  } = reducers;
  const [keyToDisplay, setKeyToDisplay] = useState({});
  useEffect(() => {
    const fetchData = async () => {
      setState((prevState) => ({
        ...prevState,
        isLoading: true,
        newHistory: [],
      }));
    };

    fetchData();

    return async () => {
      await dispatch(action.clearReducer());
    };
  }, [dispatch, devOrderId]);

  useEffect(() => {
    if (productIdentifierList && productIdentifierList.length > 0) {
      const newKeyToDisplay = {};
      productIdentifierList.forEach((key) => {
        newKeyToDisplay[key._id] = key.name;
      });
      setKeyToDisplay(newKeyToDisplay);
    }
  }, [productIdentifierList]);

  useEffect(() => {
    console.log('historyList', historyList, state.newHistory.length);
    if (historyList && historyList !== state.newHistory.length) {
      const count = historyListRecords;
      const table = cloneDeep(state.newHistory);
      setState((prev) => ({
        ...prev,
        isLoading: false,
        users: userList,
        newHistory: orderBy([...historyList], ['createdAt'], ['desc']),
        hasMore: count !== table?.length,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [historyListRecords, historyList, userList]);

  useEffect(() => {
    setState((prev) => ({ ...prev, isLoading: true }));
    const callFn = async () => {
      const newHistroyList = await Promise.all([
        dispatch(bomAction.fetchProductDetails(devOrderId)),
        dispatch(bomAction.fetchTrafficLights(devOrderId)),
        dispatch(masterAction.fetchProductIdentifier(t)),
        dispatch(action.fetchProductHIstoryList({ pageIndex: state.pageIndex, pageSize: state?.pageSize, devOrderId })),
      ]);
      if (newHistroyList) {
        setState((prev) => ({
          ...prev,
          isLoading: false,
        }));
      }
    };
    if (devOrderId) {
      callFn();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, devOrderId]);

  const renderModuleWise = (historyObj, colType) => {
    switch (historyObj?.section) {
      case 'Products':
      case 'Design/Details':
      case 'BOM':
      case 'SupportingDocuments':
      case 'Specifications':
      case 'Testing':
      case 'User Instructions':
      case 'Care User Instruction':
      case 'Samples':
      case 'Product Costing':
      case 'Purchase Orders':
      case 'Documents':
      case 'Product Listing RangePlan':
      case 'Product Listing':
      case 'Additional Information':
        return <DevelopmenorderFields historyFieldsData={historyObj?.fields} colType={colType} keyToDisplay={keyToDisplay} />;
      case 'ProductDAM':
        return <RenderLhsRhsValues historyFieldsData={historyObj?.fields} colType={colType} />;
      /* BM-9941 — cell-level changes from the Product Identifier grid, upload and sync. */
      case 'Product Identifier':
        return <ProductIdentifierFields historyFieldsData={historyObj?.fields} colType={colType} />;
      default:
        return '--';
    }
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(async () => {
      if (state.searchLoaded) {
        let table = cloneDeep(state.newHistory);
        table = [];
        setState((debouncestate) => ({
          ...debouncestate,
          isLoading: true,
          pageIndex: 1,
          newHistory: table,
          hasMore: true,
        }));
        const optns = {
          pageIndex: 1,
          pageSize: state.pageSize,
          searchText: state.searchText,
          devOrderId,
        };
        const res = await dispatch(action.fetchProductHIstoryList(optns));
        if (res) {
          setState((debstate) => ({
            ...debstate,
            isLoading: false,
            searchLoaded: false,
          }));
        }
      }
    }, 1000);

    return () => clearTimeout(delayDebounceFn);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.searchText, dispatch, state.pageIndex, state.pageSize]);

  const handleSearch = (e) => {
    const targetValue = e.target.value;
    setState((searchState) => ({
      ...searchState,
      searchText: targetValue,
      searchLoaded: true,
    }));
  };

  const handleMobileSearch = (clear) => {
    if (clear) {
      setState((mobstate) => ({
        ...mobstate,
        searchText: '',
        searchLoaded: true,
        showMobileSearch: !state.showMobileSearch,
      }));
    }
  };

  const handleNextPageInScroll = useCallback(async () => {
    let { pageIndex } = state;
    pageIndex += 1;
    setState((nextPagestate) => ({
      ...nextPagestate,
      pageIndex,
      isLoading: true,
    }));
    const params = {
      pageIndex,
      pageSize: state?.pageSize,
      searchText: state.searchText,
      devOrderId,
    };
    const result = await dispatch(action.fetchProductHIstoryList(params));
    if (result) {
      setState((nextPagestate) => ({
        ...nextPagestate,
        isLoading: false,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.newHistory]);

  const handleSequence = () => {
    for (const hist of state.newHistory) {
      const currentSeqObjec = SetSequenceForHistoryModule[hist?.section];

      if (currentSeqObjec) {
        hist.fields = hist?.fields?.sort((a, b) => {
          return (
            (currentSeqObjec[a?.field] || currentSeqObjec[a?.fieldKey] || 999) -
            (currentSeqObjec[b?.field] || currentSeqObjec[b?.fieldKey] || 999)
          );
        });
      }
    }
    return state.newHistory;
  };

  const memoizedHistory = useMemo(() => {
    return handleSequence();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.newHistory]);

  return (
    <>
      <div className="page-title-filter sticky">
        <div className="title-container d-flex align-items-center">
          <h4 className="title">
            {t('PRODUCT_HISTORY.PRODUCT_HISTORY_INDEX.TITLE')} {productDetails?.number}
          </h4>
        </div>
        <div className="search-filter action-new-row">
          <SearchBar
            onSearch={handleSearch}
            value={state.searchText}
            showMobileSearch={state.showMobileSearch}
            placeholder={t('PRODUCT_HISTORY.PRODUCT_HISTORY_INDEX.SEARCH_PLACEHOLDER')}
            handleMobileSearch={handleMobileSearch}
          />
        </div>
      </div>
      <div className="container-fluid pt-24">
        {state.isLoading && memoizedHistory.length === 0 ? (
          <div className="text-center">
            <Loader />
          </div>
        ) : (
          <div id="product_history" className="history-scroll-container">
            <InfiniteScroll
              dataLength={memoizedHistory?.length}
              loader={state.isLoading && <Loader />}
              hasMore={state.hasMore}
              next={handleNextPageInScroll}
              scrollableTarget="product_history"
              className="fixed-col-container"
            >
              <table className="table common-custom-table m-0 fixed-header table-product-history layout-fixed" id="product_history">
                <thead>
                  <tr>
                    <th className="w-150px">{t('PRODUCT_HISTORY.PRODUCT_HISTORY_INDEX.LOCATION')}</th>
                    <th className="w-200px">{t('PRODUCT_HISTORY.PRODUCT_HISTORY_INDEX.COMPONENT')}</th>
                    <th className="w-200px">{t('PRODUCT_HISTORY.PRODUCT_HISTORY_INDEX.DESCRIPTION')}</th>
                    <th className="w-150px">{t('PRODUCT_HISTORY.PRODUCT_HISTORY_INDEX.ACTION')}</th>
                    <th className="w-200px">{t('PRODUCT_HISTORY.PRODUCT_HISTORY_INDEX.FROM')}</th>
                    <th className="w-200px">{t('PRODUCT_HISTORY.PRODUCT_HISTORY_INDEX.TO')}</th>
                    <th className="w-150px">{t('PRODUCT_HISTORY.PRODUCT_HISTORY_INDEX.USER')}</th>
                    <th className="w-175px">{t('PRODUCT_HISTORY.PRODUCT_HISTORY_INDEX.DATE_TIME')}</th>
                  </tr>
                </thead>
                <tbody>
                  {isArray(memoizedHistory) && memoizedHistory.length > 0
                    ? memoizedHistory?.map((neHist) => {
                        const userDetails = state.users[neHist?.userId];
                        const subSection = neHist?.subSection ? neHist?.subSection.replace(/\w+/g, capitalize) : '';
                        return (
                          <tr key={neHist._id}>
                            <td>{neHist?.section}</td>
                            <td>{shortenandHoverString(subSection, 20) || ''}</td>
                            <td>{shortenandHoverString(neHist?.description, 20) || '--'}</td>
                            <td>{shortenandHoverString(neHist?.action, 20)}</td>
                            <td className="p-0 word-break-word">
                              {['Archived', 'Unarchived'].includes(neHist?.action) ? '--' : renderModuleWise(neHist, 'lhs')}
                            </td>
                            <td className="p-0 word-break-word">
                              {['Archived', 'Unarchived'].includes(neHist?.action) ? '--' : renderModuleWise(neHist, 'rhs')}
                            </td>
                            <td>{userDetails}</td>
                            <td>
                              {' '}
                              <span>{moment(neHist.createdAt).format('DD-MMMM-YYYY HH:mm')}</span>
                            </td>
                          </tr>
                        );
                      })
                    : null}
                  {/* )} */}
                </tbody>
              </table>
              {memoizedHistory.length === 0 ? <div className="p-3 text-center">{t('PRODUCT_HISTORY.PRODUCT_HISTORY_INDEX.NO_RECORDS')}</div> : null}
            </InfiniteScroll>
          </div>
        )}
      </div>
    </>
  );
}

export default ProductHistory;
